import React from 'react'
import Text from 'particles/Text'
import styled from 'particles/themes/styled'
import { default as BaseTooltip, TooltipProps as BaseTooltipProps, tooltipClasses } from '@mui/material/Tooltip'

interface TooltipProps extends Omit<BaseTooltipProps, 'title'> {
    title?: React.ReactNode
    label?: React.ReactNode
    placement?: TooltipPlacement
}

export type TooltipPlacement =
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'

const Tooltip: React.FC<TooltipProps> = ({ className, title, label, ...props }) => (
    <BaseTooltip
        {...props}
        classes={{ popper: className }}
        title={
            title || label ? (
                <>
                    {title &&
                        (React.isValidElement(title) ? (
                            title
                        ) : (
                            <Text scale="caption700" color="primaryInverse">
                                {title}
                            </Text>
                        ))}
                    {label &&
                        (React.isValidElement(label) ? (
                            label
                        ) : (
                            <Text scale="caption400" color="primaryInverse">
                                {label}
                            </Text>
                        ))}
                </>
            ) : (
                ''
            )
        }
        componentsProps={{
            popper: {
                sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                        marginTop: '0px',
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
                        marginBottom: '0px',
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
                        marginLeft: '0px',
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
                        marginRight: '0px',
                    },
                },
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 4],
                        },
                    },
                ],
            },
        }}
    />
)

export default styled(Tooltip)`
    & .${tooltipClasses.tooltip} {
        border-radius: 4px;
        background-color: ${({ theme }) => theme.colors.surface.secondaryInverse};
        font-family: inherit;
        display: flex;
        max-width: 224px;
        box-sizing: border-box;
        padding: 8px 12px;
        flex-direction: column;
        align-items: flex-start;
        gap: ${({ theme }) => theme.spacing[200]};
        box-shadow: ${({ theme }) => theme.shadows.level3};
    }
`
